export default "__VITE_ASSET__DzkritMs__"